import { ToggleButtonGroup } from '@mui/material';
import { useIntl } from 'react-intl';
import { StyledToggleButton } from 'components/StyledToggleButton';
import type { CalendarGranularity } from '../types';
import { useDateRangePickerContext } from '../context/DateRangePickerContext';

export function GranularityToggle() {
  const { granularity, allowedGranularities, onGranularityChange } = useDateRangePickerContext();
  const intl = useIntl();

  if (!allowedGranularities || !onGranularityChange) return null;

  const handleChange = (_event: React.MouseEvent<HTMLElement>, newValue: CalendarGranularity) => {
    if (newValue) {
      onGranularityChange(newValue);
    }
  };

  return (
    <ToggleButtonGroup value={granularity} exclusive onChange={handleChange} size="small">
      {allowedGranularities.map(opt => (
        <StyledToggleButton
          key={opt.value}
          value={opt.value}
          className="whitespace-nowrap normal-case px-4 py-2"
          sx={{ fontSize: '14px' }}
        >
          {intl.formatMessage({ id: opt.labelId, defaultMessage: opt.labelId })}
        </StyledToggleButton>
      ))}
    </ToggleButtonGroup>
  );
}
